function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "_05-Qr_Code",
  "data-name": "05-Qr Code"
}, /*#__PURE__*/React.createElement("path", {
  d: "m17 9h32v36h-32z",
  fill: "#ffc170"
}), /*#__PURE__*/React.createElement("path", {
  d: "m21 37v-28h-4v36h32v-4h-24a4 4 0 0 1 -4-4z",
  fill: "#fc9942"
}), /*#__PURE__*/React.createElement("path", {
  d: "m49 45v6a2.006 2.006 0 0 1 -2 2h-28a2.006 2.006 0 0 1 -2-2v-6z",
  fill: "#f2f6fc"
}), /*#__PURE__*/React.createElement("path", {
  d: "m21 51v-6h-4v6a2.006 2.006 0 0 0 2 2h4a2.006 2.006 0 0 1 -2-2z",
  fill: "#cdd2e1"
}), /*#__PURE__*/React.createElement("path", {
  d: "m49 3v6h-32v-6a2.006 2.006 0 0 1 2-2h28a2.006 2.006 0 0 1 2 2z",
  fill: "#f2f6fc"
}), /*#__PURE__*/React.createElement("path", {
  d: "m23 1h-4a2.006 2.006 0 0 0 -2 2v6h4v-6a2.006 2.006 0 0 1 2-2z",
  fill: "#cdd2e1"
}), /*#__PURE__*/React.createElement("path", {
  d: "m29 4h8v2h-8z",
  fill: "#414952"
}), /*#__PURE__*/React.createElement("path", {
  d: "m29 48h8v2h-8z",
  fill: "#414952"
}), /*#__PURE__*/React.createElement("path", {
  d: "m31 5h-28a2 2 0 0 0 -2 2v28a2 2 0 0 0 2 2h19l4 4v-4h5a2 2 0 0 0 2-2v-28a2 2 0 0 0 -2-2z",
  fill: "#ff636e"
}), /*#__PURE__*/React.createElement("path", {
  d: "m3 35v-28a2 2 0 0 1 2-2h-2a2 2 0 0 0 -2 2v28a2 2 0 0 0 2 2h2a2 2 0 0 1 -2-2z",
  fill: "#f03049"
}), /*#__PURE__*/React.createElement("path", {
  d: "m24 37h-2l4 4v-2z",
  fill: "#f03049"
}), /*#__PURE__*/React.createElement("path", {
  d: "m5 9h6v6h-6z",
  fill: "#f2f6fc"
}), /*#__PURE__*/React.createElement("path", {
  d: "m23 9h6v6h-6z",
  fill: "#f2f6fc"
}), /*#__PURE__*/React.createElement("path", {
  d: "m23 27h6v6h-6z",
  fill: "#f2f6fc"
}), /*#__PURE__*/React.createElement("path", {
  d: "m5 27h6v6h-6z",
  fill: "#f2f6fc"
}), /*#__PURE__*/React.createElement("path", {
  d: "m45 12h-4v2h3v3h2v-4a1 1 0 0 0 -1-1z",
  fill: "#fc9942"
}), /*#__PURE__*/React.createElement("path", {
  d: "m44 18h2v9h-2z",
  fill: "#fc9942"
}), /*#__PURE__*/React.createElement("path", {
  d: "m35 32h5v2h-5z",
  fill: "#fc9942"
}), /*#__PURE__*/React.createElement("path", {
  d: "m44 32h-2v2h3a1 1 0 0 0 1-1v-4h-2z",
  fill: "#fc9942"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#636978"
}, /*#__PURE__*/React.createElement("path", {
  d: "m7 11h2v2h-2z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m25 11h2v2h-2z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m25 29h2v2h-2z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m7 29h2v2h-2z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m27 15h-2v3h-5v-5h3v-2h-3v-3h-2v3h-7v2h3v5h-5v-3h-2v7h-3v2h3v3h2v-3h5v5h-3v2h3v3h2v-3h7v-2h-3v-5h5v3h2v-7h3v-2h-3zm-11-2h2v5h-2zm2 7v2h-2v-2zm-9 2v-2h5v2zm9 7h-2v-5h2zm7-7h-5v-2h5z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m28 22h2v2h-2z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m4 18h2v2h-2z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m18 32h2v2h-2z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m14 8h2v2h-2z"
})), /*#__PURE__*/React.createElement("path", {
  d: "m52.5 53.5 5.5-5.5 1-1 4 4-12 12-4-4 1-1z",
  fill: "#ff9696"
}), /*#__PURE__*/React.createElement("path", {
  d: "m63 51v12h-12z",
  fill: "#ff636e"
}), /*#__PURE__*/React.createElement("path", {
  d: "m51 28v8h-2v-10z",
  fill: "#faa68e"
}), /*#__PURE__*/React.createElement("path", {
  d: "m51 52 1.5 1.5-4.5 4.5-5-5h4a2.006 2.006 0 0 0 2-2v-6h2z",
  fill: "#faa68e"
}), /*#__PURE__*/React.createElement("path", {
  d: "m56 46 2 2-5.5 5.5-1.5-1.5v-7h-2c-7 0-7-7-7-7l-1-1a5.649 5.649 0 0 1 0-8l7 7h3v-8l-2-2v-4l5 3z",
  fill: "#ffcdbe"
}), /*#__PURE__*/React.createElement("path", {
  d: "m63.707 50.293-4-4a1 1 0 0 0 -1.414 0l-.293.293-1.039-1.039-1.961-20.642a1 1 0 0 0 -.48-.762l-4.52-2.709v-18.434a3 3 0 0 0 -3-3h-28a3 3 0 0 0 -3 3h2a1 1 0 0 1 1-1h28a1 1 0 0 1 1 1v5h-13v2h13v24.586l-2-2v-3.586h-2v1.586l-2.293-2.293a1 1 0 0 0 -1.414 0 6.609 6.609 0 0 0 -1.864 3.707h-3.429v2h3.429a6.609 6.609 0 0 0 1.864 3.707l.72.72a8.536 8.536 0 0 0 2.471 5.573h-25.484v-5h-2v12a3 3 0 0 0 3 3h23.586l4 4-.293.293a1 1 0 0 0 0 1.414l4 4a1 1 0 0 0 .707.293h12a1 1 0 0 0 1-1v-12a1 1 0 0 0 -.293-.707zm-45.707.707v-5h30v5a1 1 0 0 1 -1 1h-28a1 1 0 0 1 -1-1zm29 3a3 3 0 0 0 3-3v-5h1v-2h-2c-5.8 0-6-5.389-6-6a1 1 0 0 0 -.293-.707l-1-1a4.666 4.666 0 0 1 -.631-5.8l6.217 6.216a1 1 0 0 0 .707.291h3v-2h-1v-11.234l3.053 1.834 1.952 20.5a1 1 0 0 0 .288.612l1.293 1.288-8.586 8.586-2.586-2.586zm1.414 5 .293-.293 10-10 .293-.293 2.586 2.586-10.586 10.586zm5 3 8.586-8.586v8.586z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m29 48h8v2h-8z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m25.293 41.707a1 1 0 0 0 1.707-.707v-3h4a3 3 0 0 0 3-3v-28a3 3 0 0 0 -3-3h-28a3 3 0 0 0 -3 3v28a3 3 0 0 0 3 3h18.586zm-23.293-6.707v-28a1 1 0 0 1 1-1h28a1 1 0 0 1 1 1v28a1 1 0 0 1 -1 1h-5a1 1 0 0 0 -1 1v1.586l-2.293-2.293a1 1 0 0 0 -.707-.293h-19a1 1 0 0 1 -1-1z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m46 13a1 1 0 0 0 -1-1h-4v2h3v3h2z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m44 18h2v9h-2z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m7 11h2v2h-2z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m25 11h2v2h-2z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m25 29h2v2h-2z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m7 29h2v2h-2z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m22 31v2a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-6a1 1 0 0 0 -1-1h-2v-6h3v-2h-3v-2h2a1 1 0 0 0 1-1v-6a1 1 0 0 0 -1-1h-6a1 1 0 0 0 -1 1v2h-2v-3h-2v3h-6v-2a1 1 0 0 0 -1-1h-6a1 1 0 0 0 -1 1v6a1 1 0 0 0 1 1h2v6h-3v2h3v2h-2a1 1 0 0 0 -1 1v6a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-2h2v3h2v-3zm-4-7v5h-2v-5zm-2-2v-2h2v2zm12 10h-4v-4h4zm-5-6a1 1 0 0 0 -1 1v2h-2v-5h5v2zm2-4h-5v-2h5zm-1-12h4v4h-4zm-2 3v2a1 1 0 0 0 1 1h2v2h-5v-5zm-4 5h-2v-5h2zm-12-8h4v4h-4zm5 6a1 1 0 0 0 1-1v-2h2v5h-5v-2zm-2 4h5v2h-5zm1 12h-4v-4h4zm2-3v-2a1 1 0 0 0 -1-1h-2v-2h5v5z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m28 22h2v2h-2z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m4 18h2v2h-2z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m18 32h2v2h-2z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m14 8h2v2h-2z"
}));

var SvgQrCode = function SvgQrCode(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 64 64",
    width: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgQrCode, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/qr-code.1a4dab18.svg";
export { ForwardRef as ReactComponent };